import { render, staticRenderFns } from "./BeforeAbandonEditsModal.vue?vue&type=template&id=42e285fe&scoped=true"
import script from "./BeforeAbandonEditsModal.vue?vue&type=script&lang=ts"
export * from "./BeforeAbandonEditsModal.vue?vue&type=script&lang=ts"
import style0 from "./BeforeAbandonEditsModal.vue?vue&type=style&index=0&id=42e285fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e285fe",
  null
  
)

export default component.exports